"use client";

import { usePathname } from "next/navigation";
import { ExternalLink } from "@/components/ui/external-link";

export function EventsFooterAttribution() {
  const pathname = usePathname();

  if (pathname !== "/events") {
    return null;
  }

  return (
    <div className="text-muted-foreground text-base">
      Boundaries courtesy of{" "}
      <ExternalLink
        href="https://www.geoboundaries.org"
        className="underline underline-offset-4"
      >
        geoBoundaries
      </ExternalLink>
    </div>
  );
}
